import React from "react";

const AddSpacing = ({ spacing = 10, children }) => {
  return (
    <>
      {children.map((child, key) => (
        <div
          key={key}
          style={{ marginBottom: spacing, marginTop: spacing, width: "100%" }}
        >
          {child}
        </div>
      ))}
    </>
  );
};

export default AddSpacing;
